import i18n from '@/i18n';
import { carBodyTypes } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const CarBodyTypes = () => import('./views/Index.vue');

export default [
  {
    path: 'car-body-types',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.CarBodyTypes`,
        component: CarBodyTypes,
        meta: {
          title: i18n.global.t('carBodyTypes.carBodyTypes'),
          permission: { module: carBodyTypes.module, key: carBodyTypes.showAll },
        },
      },
    ],
  },
];
